export var buildEnv = {
    buildMode: 'release',
    datacenter: 'us',
    sdkVersion: '2.10.0',
};
//# sourceMappingURL=buildEnv.js.map